import { Events, Actions } from "@events";

class TextChannel {
  /**
   * @type {import('./webrtcRoom').default}
   */
  webRtcRoom = null;

  constructor(webRtcRoom) {
    this.webRtcRoom = webRtcRoom;
    this.rtcId = webRtcRoom.rtcId;
    this.clientId = webRtcRoom.clientId;
    this.storedMessages = [];

    this.sendChannel = null;
    this.receiveChannel = null;

    if (!this.webRtcRoom.peerConnection.createDataChannel) {
      throw new Error("createDataChannel is not supported");
    }

    this.sendChannel = this.webRtcRoom.peerConnection.createDataChannel("sendTextChannel");

    this.webRtcRoom.peerConnection.addEventListener("datachannel", (event) => {
      if (event.channel.label == "sendTextChannel") {
        this.receiveChannel = event.channel;
        this.receiveChannel.addEventListener("message", (event) => {
          console.log("TEXT_CHANNEL_LOG : text channel message received ", event.data);
          this.webRtcRoom.callEventEmitter.emit(Events.TextChannelMessageReceived, {
            data: event.data,
            channel: this.receiveChannel.label,
          });
        });
      } else {
        console.log(`TextChannel => on datachannel, channel label was ${event.channel.label}, skipped handler`);
      }
    });

    this.sendChannel.onopen = () => {
      console.log("TEXT_CHANNEL_LOG : text channel open");
      this.webRtcRoom.state.addConnectionLog(`TEXT-CHANNEL-OPEN`);
      // send stored messages
      this.storedMessages.forEach((message) => {
        this.send(message);
      });
      this.storedMessages = [];
    };

    this.sendChannel.onclose = () => {
      console.log("TEXT_CHANNEL_LOG : text channel close");
      this.webRtcRoom.state.addConnectionLog(`TEXT-CHANNEL-CLOSE`);
    };

    this.webRtcRoom.localActionEmitter.on(Actions.SendTextChannelMessage, ({ message }) => {
      this.send(message);
    });
  }

  send(value) {
    if (!this.sendChannel) {
      console.log("TEXT_CHANNEL_LOG : text channel not initialized");
      this.webRtcRoom.state.addConnectionLog(`TEXT-CHANNEL-SEND-ERROR-NOT-INITIALIZED`);
      return;
    }

    const state = this.sendChannel.readyState;

    if (state !== "open") {
      this.storedMessages.push(value);
      console.log("TEXT_CHANNEL_LOG : text channel not open , message stored", value);
      return;
    }

    this.sendChannel.send(value);

    this.webRtcRoom.callEventEmitter.emit(Events.TextChannelMessageSent, {
      data: value,
      channel: this.sendChannel.label,
    });

    console.log("TEXT_CHANNEL_LOG : text channel message sent ", value);
  }
}

export { TextChannel };
